import React, { useContext, useEffect } from "react";

// core components
import { Sidebar } from "core/AssetDownload";
import DownloadPhotoButton from "./components/DownloadPhotoButton";
import { PhotoBuyBox } from "../PhotoBuyBox";

import AssetDownloadContext from "core/AssetDownload/Context";
import { setIsReadyForDownload } from "core/AssetDownload/Context/actions";
import { useAuth } from "frontend/hooks/useAuth";

const PhotoDetailSidebar = () => {
    const { currentUser } = useAuth();
    const isCreativePro = currentUser?.hasCreativeProSubscription;
    const { state, dispatch } = useContext(AssetDownloadContext);
    const { isReadyForDownload, asset = {} } = state;
    const { isPremium } = asset;
    const isStandardPhoto = isPremium === false;

    // creative pro subs should get standard photos with no purchase
    useEffect(() => {
        if (isCreativePro && isStandardPhoto && !isReadyForDownload) {
            dispatch(setIsReadyForDownload(true));
        }
    }, [isReadyForDownload, isPremium, isCreativePro]);

    return (
        <Sidebar>
            {isReadyForDownload ? <DownloadPhotoButton /> : <PhotoBuyBox />}
        </Sidebar>
    );
};

export default PhotoDetailSidebar;
